export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const CHANGE_KEY_PAD_COL = 'CHANGE_KEY_PAD_COL';
export const CHANGE_KEY_PAD_ROW = 'CHANGE_KEY_PAD_ROW';
export const TOGGLE_KEY_PAD = 'TOGGLE_KEY_PAD';
